export default __webpack_public_path__ + "static/media/modal10.4e90fbef.jpg";